import React, { useMemo } from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';

import { ChartWrapper } from 'src/components';
import { eeccCategoriesMapper } from 'src/utils/eeccCategoriesMapper';


const useStyles = makeStyles(theme => ({
  chartContainer: {
    height: '300px',
    width: '100%',
    borderRadius: theme.shape.borderRadius,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.common.gray400,
  },
  subtitle: {
    fontWeight: 500,
    textTransform: 'uppercase',
    color: theme.palette.common.gray600,
    lineHeight: 1,
  },
}));

const SitesConservationChart = () => {
  const classes = useStyles();

  // Datos de estado de conservación
  const conservationData = [
    { symbol: 'EX', text: eeccCategoriesMapper.EX.text, value: 0, color: eeccCategoriesMapper.EX.backgroundColor },
    { symbol: 'EW', text: eeccCategoriesMapper.EW.text, value: 0, color: eeccCategoriesMapper.EW.backgroundColor },
    { symbol: 'CR', text: eeccCategoriesMapper.CR.text, value: 2, color: eeccCategoriesMapper.CR.backgroundColor },
    { symbol: 'EN', text: eeccCategoriesMapper.EN.text, value: 4, color: eeccCategoriesMapper.EN.backgroundColor },
    { symbol: 'VU', text: eeccCategoriesMapper.VU.text, value: 9, color: eeccCategoriesMapper.VU.backgroundColor },
    { symbol: 'NT', text: eeccCategoriesMapper.NT.text, value: 10, color: eeccCategoriesMapper.NT.backgroundColor },
    { symbol: 'LC', text: eeccCategoriesMapper.LC.text, value: 15, color: eeccCategoriesMapper.LC.backgroundColor },
  ];

  // Filtrar solo los datos con valor > 0 para el gráfico
  const filteredData = conservationData.filter(item => item.value > 0);

  const chartData = useMemo(() => ({
    labels: filteredData.map(item => `${item.symbol} - ${item.text}`),
    datasets: [
      {
        data: filteredData.map(item => item.value),
        backgroundColor: filteredData.map(item => item.color),
        borderWidth: 1,
        borderColor: '#ffffff',
      },
    ],
  }), [ filteredData ]);

  const chartOptions = useMemo(() => ({
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        callbacks: {
          label: context => {
            const dataItem = filteredData[context.dataIndex];
            const percentage = ((context.parsed / filteredData.reduce((sum, item) => sum + item.value, 0)) * 100).toFixed(1);
            return `${dataItem.symbol} - ${dataItem.text}: ${context.parsed} (${percentage}%)`;
          },
          labelColor: context => ({
            borderColor: filteredData[context.dataIndex].color,
            backgroundColor: filteredData[context.dataIndex].color,
          }),
        },
      },
      legend: {
        position: 'bottom',
        labels: {
          generateLabels: chart => {
            const data = chart.data;
            return data.labels.map((label, i) => ({
              text: label,
              fillStyle: data.datasets[0].backgroundColor[i],
              strokeStyle: data.datasets[0].backgroundColor[i],
              lineWidth: 1,
              hidden: isNaN(data.datasets[0].data[i]) || chart.getDatasetMeta(0).data[i].hidden,
              index: i,
            }));
          },
          boxWidth: 12,
          padding: 10,
          font: {
            size: 10,
          },
        },
      },
    },
  }), [ filteredData ]);

  return (
    <Box mt={2}>
      <Typography className={classes.subtitle} variant="body2" component="span">
        Estado de Conservación de Especies
      </Typography>
      <Box p={2} className={classes.chartContainer}>
        <ChartWrapper
          type="pie"
          data={chartData}
          options={chartOptions}
        />
      </Box>
    </Box>
  );
};


export { SitesConservationChart };